import { Get } from '../requestBuilder/buildFetchRequest';
import PagedResponse from '../PagedResponse';
import Project from './Project';
import ProjectQueryOptions from './ProjectQueryOptions';
import { QueryParameters, buildQueryParams } from '../QueryParameters';

export const getProjects = (query: QueryParameters<Project, ProjectQueryOptions>): Promise<PagedResponse<Project>> => (
  Get('/api/projects')
    .AddQueryParams(buildQueryParams(query))
    .Execute()
);

export const getProjectsByCompany = (companyId: number, query: QueryParameters<Project, ProjectQueryOptions>): Promise<PagedResponse<Project>> => (
  Get(`/api/companies/${companyId}/projects`)
    .AddQueryParams({ ...buildQueryParams(query), companyId })
    .Execute()
);

export const getProject = (projectId: number): Promise<Project> => (
  Get(`/api/projects/${projectId}`)
    .Execute()
);
